import { canonicalizeRole } from './permissions';

/**
 * Role helpers that sit NEXT TO the permission catalog without touching it (permissions.ts is pinned in lockstep with
 * the C# catalog and the admin-portal mirror, so nothing is added there).
 *
 * UX only, never authorization: the server evaluates the same roles per request.
 */

/**
 * The canonical form of a raw role-claim array: each role canonicalised (case-insensitive, legacy aliases mapped),
 * blanks dropped, duplicates removed, order kept. An unknown role passes through unchanged and so contributes nothing
 * downstream. No roles in, no roles out (fail closed).
 */
export function canonicalRoles(raw: readonly string[] | null | undefined): string[] {
  const out: string[] = [];
  for (const r of raw ?? []) {
    if (typeof r !== 'string' || r.trim().length === 0) continue;
    const c = canonicalizeRole(r);
    if (!out.includes(c)) out.push(c);
  }
  return out;
}

/**
 * Is this a tenant administrator (ADR-033 D2)? True for `admin` and `platformAdmin` after canonicalisation - the two
 * admin types of ADR-008. A senior agent is NOT one (it may read everyone's conversations, not return them to the
 * team), and neither is the additive `developer` overlay.
 */
export function isTenantAdmin(roles: readonly string[] | null | undefined): boolean {
  const canonical = canonicalRoles(roles);
  return canonical.includes('admin') || canonical.includes('platformAdmin');
}
